import { useEffect, useContext } from 'react';

import AppContext from '../context';

export const useHeaderVersion = (): void => {
    const { backendHeaderVersion } = useContext(AppContext);

    useEffect(() => {
        window.shopHeaderMetaData = {
            frontend: process.env.SENTRY_RELEASE,
            backend: backendHeaderVersion,
        };
    }, []);
};
